// @flow

import React from 'react';
import type { FieldProps } from 'redux-form';
import LabeledInput from '../labeledInput';
import { ReduxformTextarea } from '../../textarea';

type Props = {
  // $FlowFixMe
  ...FieldProps,
  label: string,
  placeholder: string,
  type?: string,
};

const LabeledTextarea = ({ label, ...rest }: Props) => (
  <LabeledInput label={label}>
    <ReduxformTextarea {...rest} />
  </LabeledInput>
);

LabeledTextarea.defaultProps = {
  type: '',
};

export default LabeledTextarea;
